module.exports = __webpack_public_path__ + "img/2018.06.ea329ace.jpg";